import { useState, useEffect } from "react";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../usecontext/AuthContext";
import { encryptTimestamp } from "../commoncsrf/csrf-common";

const useQueueColumns = (queueName) => {
    const [tableColumns, setTableColumns] = useState([]);
    const [columnsLoading, setColumnsLoading] = useState(false);
    const { accessToken } = useAuthToken();

    useEffect(() => {
        const fetchColumns = async () => {
            setColumnsLoading(true);
            try {
                const myHeaders = {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                };
                const response = await fetch(CommonObj.Endpoints.GetQueueColumnMaster, {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify({QueueName:queueName}),
                });
                if (!response.ok) return;
                const columns = await response.json();
                if (Array.isArray(columns) && columns.length > 0) {
                    setTableColumns(
                        columns.map((col) => ({
                            title: col.displayColumnName,
                            dataIndex: col.keyName,
                            key: col.keyName,
                            width: 160,
                        }))
                    );
                }
            } catch (err) {
                console.error("Failed to fetch column master", err);
            } finally {
                setColumnsLoading(false);
            }
        };
        if (queueName) fetchColumns();
    }, [accessToken, queueName]);

    return { tableColumns, columnsLoading };
};

export default useQueueColumns;
